export enum RENDEZVOUS_API_CLIENT_ERROR_CODES {
    USER_DEVICE_ACTIVATION_CODE_NOT_FOUND = 'user_device_activation_code_not_found',
}

export const RENDEZVOUS_ERROR_STATUS_CODES = [400];

export const RENDEZVOUS_API_CLIENT_ERROR_CODES_MAP: Record<string, string> & { DEFAULT: string } = {
    [RENDEZVOUS_API_CLIENT_ERROR_CODES.USER_DEVICE_ACTIVATION_CODE_NOT_FOUND]:
        'The activation code you entered is invalid. Please try again.',
    DEFAULT: 'Activation failed. Please try again.',
};
